module.exports = __webpack_public_path__ + "img/galeria-mascotes1.c6961987.jpg";